<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <el-form
            :inline="true"
            :model="filter"
            ref="filterForm"
            label-position="right"
            label-width="80px"
            class="search-form"
            size="mini"
          >
            <el-form-item label="维修基地" prop="fix_base">
              <FixBaseSelect
                v-model="filter.fix_base"
                :search="true"
              ></FixBaseSelect>
            </el-form-item>
            <el-form-item label="钻头类型" prop="drill_type">
              <el-select v-model="filter.drill_type" size="small" clearable>
                <el-option :value="2" label="PDC钻头" key="2"></el-option>
                <el-option :value="3" label="复合钻头" key="3"></el-option>
                <el-option :value="4" label="矿用钻头" key="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格" prop="drill_size">
              <param-select
                category="1"
                v-model="filter.drill_size"
              ></param-select>
            </el-form-item>
            <el-form-item label="钻头型号" prop="model_number">
              <el-input
                clearable
                v-model="filter.model_number"
                placeholder="钻头型号"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="零件号" prop="component_number">
              <el-input
                clearable
                v-model="filter.component_number"
                placeholder="零件号"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="序列号" prop="serial_number">
              <el-input
                clearable
                v-model="filter.serial_number"
                placeholder="序列号"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                clearable
                v-model="filter.remark"
                placeholder="备注"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="下单日期" prop="date">
              <el-date-picker
                clearable
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <div style="margin-left: 80px">
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
        </div>

        <div class="panel">
          <div class="panel-heading">
            <div class="panel-control flex">
              <btn-tag
                :btn="true"
                :slotBtn="true"
                :auth-id="32108"
                module-name="orders"
                v-if="orderModule == 'orders_archive'"
              >
                <file-button
                  class="mobile-hide"
                  :exportButton="false"
                  btnType="default"
                  obj="order"
                  @importCallback="reset"
                ></file-button>
              </btn-tag>

              <btn-tag
                :btn="true"
                :slotBtn="true"
                :auth-id="32108"
                module-name="orders"
                v-if="orderModule == 'orders_archive'"
              >
                <el-button size="small" @click="handleExportOrderTemp"
                  >下载模板</el-button
                >
              </btn-tag>
              <el-select
                v-model="filter.size"
                size="small"
                style="width: 123px; margin-left: 10px"
              >
                <el-option label="10条/每页" key="1" :value="10"></el-option>
                <el-option label="30条/每页" key="2" :value="30"></el-option>
                <el-option label="50条/每页" key="3" :value="50"></el-option>
                <el-option label="100条/每页" key="4" :value="100"></el-option>
                <el-option label="500条/每页" key="5" :value="500"></el-option>
              </el-select>
              <el-button size="small" class="ml-10" @click="handleExportOrder">
                导出当前页订单
              </el-button>
            </div>
            <h3 class="panel-title pl-0">{{ $route.meta.name }}列表</h3>
          </div>

          <div>
            <order-table :items="orders.list" :loading="loading"></order-table>
            <pagination
              :records="orders.count"
              :page="filter.page"
              :per-page="filter.size"
              @paginate="loadData"
            >
            </pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderList, orderExport } from '@/service/getData'
import OrderTable from './table'
import { deepClone } from '@/utils'
import ParamSelect from '@/components/select/param_select'

export default {
  components: {
    OrderTable,
    ParamSelect,
  },
  data() {
    return {
      orderModule: this.$route.meta.en_name,
      filter: {
        page: 1,
        size: 10,
        drill_type: '',
        drill_size: '',
        model_number: '',
        component_number: '',
        serial_number: '',
        fix_base: '',
        date: '',
        remark: '',
      },
      loading: false,
      orders: {
        list: [],
        count: 0,
      },
    }
  },
  watch: {
    $route: function (to, from) {
      if (to.path == from.path) {
        return
      } else {
        this.reset()
        this.orderModule = this.$route.meta.en_name
      }
    },
    'filter.size': function () {
      this.filter.page = 1
      this.getData()
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    reset() {
      this.filter = {
        page: 1,
        size: 10,
        drill_type: '',
        drill_size: '',
        model_number: '',
        component_number: '',
        serial_number: '',
        fix_base: '',
        date: '',
        remark: '',
      }
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = deepClone(this.filter)
      if (this.$route.meta.en_name == 'orders') {
        params.status = 100
      } else if (this.$route.meta.en_name == 'orders_ongoing') {
        params.option_status = 1
      } else if (this.$route.meta.en_name == 'orders_pause') {
        params.option_status = 2
      } else if (this.$route.meta.en_name == 'orders_close') {
        params.option_status = 3
      } else if (this.$route.meta.en_name == 'orders_archive') {
        params.status = 6
      }

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      params.page -= 1
      params.remark = encodeURIComponent(params.remark)
      this.loading = true
      let res = await orderList(params)
      if (res.status != 0) return false
      this.orders = res.data
      this.loading = false
    },
    async loadData(page) {
      this.filter.page = page
      this.getData()
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            case 'is_drill_new':
              return v[j] == 2 ? '旧' : '新'
            case 'factory':
              return v[j].name
            case 'created_at':
              return this.$time(v[j]).format('YYYY-MM-DD')
            default:
              return v[j]
          }
        }),
      )
    },
    formartOrderList(list) {
      let data = []
      let merges = []

      let rowIndex = 0
      list.map((item) => {
        rowIndex++
        if (item.drills.length == 0) {
          data.push(item)
        } else {
          item.drills.map((drill, index) => {
            if (index > 0) {
              rowIndex++
            }
            let item_drill = deepClone(item)
            item_drill.serial_number = drill.serial_number
            item_drill.drill_status_name =
              drill.status == 1 ? '已到达' : '未到达'
            item_drill.drill_receive_time =
              drill.status == 1 && drill.receive_time
                ? this.$time(item.receive_time).format('YYYY-MM-DD HH:mm')
                : ''
            data.push(item_drill)
          })

          if (item.drills.length > 1) {
            for (var i = 0; i < 20; i++) {
              merges.push({
                s: { r: rowIndex - item.drills.length + 1, c: i },
                e: { r: rowIndex, c: i },
              })
            }
          }
        }
      })
      return { list: data, merges: merges }
    },
    handleExportOrder() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          '订单号',
          '创建人',
          '创建时间',
          '进度',
          '状态',
          '钻头类型',
          '维修基地',
          '规格',
          '型号',
          '零件号',
          // '钻头数量',
          '使用区块',
          '成品个数',
          '半成品个数',
          '交货紧急程度',
          '销售类型',
          '喷嘴安装方式',
          '喷嘴',
          '包装',
          '备注',
          '外协厂家',
          '交货时间',
          '钻头序列号',
          '钻头状态',
          '钻头到达时间',
        ]
        const filterVal = [
          'order_number',
          'user_name',
          'created_at',
          'status_name',
          'option_status_name',
          'drill_type_name',
          'fix_base_name',
          'drill_size',
          'model_number',
          'component_number',
          // 'drill_number',
          'block_info',
          'cut_count_all',
          'cut_count_half',
          'urgent_level_info',
          'sale_type_info',
          'nozzle_install_info',
          'nozzle',
          'package_type_info',
          'remark',
          'factory',
          'deliver_time',
          'serial_number',
          'drill_status_name',
          'drill_receive_time',
        ]
        const d = this.formartOrderList(this.orders.list)
        const data = this.formatJson(filterVal, d.list)

        console.log(data)
        excel.export_json_to_excel({
          header: tHeader,
          // merges: d.merges,
          data,
          filename: '订单列表',
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
    },

    handleExportOrderTemp() {
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          '订单号',
          '创建人',
          '创建时间',
          '钻头序列号',
          '是否新钻头',
          '钻头类型',
          '维修基地',
          '规格',
          '型号',
          '零件号',
          '使用区块',
          '成品个数',
          '半成品个数',
          '销售类型',
          '喷嘴安装方式',
          '喷嘴',
          '包装',
          '备注',
        ]
        excel.export_json_to_excel({
          header: tHeader,
          data: [],
          filename: '订单导入模板',
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
      })
    },
  },
}
</script>
<style scoped>
.panel-control.flex {
  display: flex;
  align-items: center;
  /* margin-top: 10px; */
  padding-right: 0;
}
</style>
